/* eslint-disable no-template-curly-in-string */

import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, LongTextInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CodeMirrorInput from '../../../../Common/Utils/CodeMirrorInput';
import ConfirmDestroy from '../../../../Common/Buttons/ConfirmDestroy';
import CreateItem from '../../../../Common/Partials/CreateItem';

const macroText = "${COUNTRY}, ${PAGE}, ${PAGE_DOMAIN}, ${PAGE_TOP_LEVEL_DOMAIN}, ${USER_IP}, ${USER_AGENT_BROWSER}, ${USER_AGENT_OS}, ${USER_AGENT_DEVICE}, ${REQUEST_ID}, ${VISITOR_ID}, ${CACHEBUSTER}";
const macroMapText = "${<MACRO>:<KEY>} eg: ${PAGE_DOMAIN:BLUEKAI_ID}";

const styles = createStyles({
  content: {
    width: '90%'
  },
  name: {
    width: '80%'
  },
  order: {
    marginTop: -25,
    width: 50
  }
});

type Props = {
  classes: any,
  fields: any
};

const PixelSettings = (props: Props) => (
  <div>
    {props.fields.length > 0 && props.fields.map((item, index) => {
      const field = props.fields.get(index);
      if (field && field._destroy) {
        return false
      }

      return (
        <div key={index}>
          <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', padding: 25 }}>
            <div style={{ width: '90%' }}>
              <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>
                  <Field name={`${item}.active`} source={`${item}.active`} component={BooleanInput} label="Active" style={{ width: '0' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <Field name={`${item}.onready`} source={`${item}.onready`} component={BooleanInput} label="Onready" style={{ width: '0' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <Field name={`${item}.refreshable`} source={`${item}.refreshable`} component={BooleanInput} label="Refreshable" style={{ width: '0' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <Field name={`${item}.order`} source={`${item}.order`} component={TextInput} label="Order" className={props.classes.order} />
                </div>
              </div>
            </div>
            <Field name={`${item}.name`} source={`${item}.name`} component={LongTextInput} label="Name" className={props.classes.name} /><br /><br />
            <Field name={`${item}.content`} component={CodeMirrorInput} label="Content - must be ECMA5 compatible" mode="javascript" />
            <div style={{ display: 'inline' }}>
              <Field name={`${item}._destroy`} source={`${item}._destroy`} component={ConfirmDestroy} />
            </div>
          </div><br /><br />
        </div>
      )
    })}
    <div style={{ paddingTop: 20 }}>
      <CreateItem fields={props.fields} label="Add Pixel" />
    </div>
    <div style={{ display: 'inline-block' }}>
      Accessible Macros:
      <div style={{ fontStyle: 'italic', fontSize: 10, padding: '0 0 10px' }}> {macroText} </div>
      Macro Map Format:
      <div style={{ fontStyle: 'italic', fontSize: 10, padding: '0 0 10px' }}>{macroMapText}</div>
    </div>
  </div>
);

export default withStyles(styles)(PixelSettings);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/PixelSettings.tsx